import { render, staticRenderFns } from "./categoriesVisibility.vue?vue&type=template&id=485ad4ca&scoped=true"
import script from "./categoriesVisibility.vue?vue&type=script&lang=js"
export * from "./categoriesVisibility.vue?vue&type=script&lang=js"
import style0 from "./categoriesVisibility.vue?vue&type=style&index=0&id=485ad4ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485ad4ca",
  null
  
)

export default component.exports